import { inject } from 'vue'

import type { ComputedRef, InjectionKey, SlotsType } from 'vue'

// eslint-disable-next-line eslint-comments/no-unlimited-disable
export const TAB_STATUS_KEY: InjectionKey<ComputedRef<boolean>> = Symbol()
export const TAB_KEY: InjectionKey<SlotsType> = Symbol('xzxTab')

export const useTabStatus = () => inject(TAB_STATUS_KEY, null)
